import type { TokenAmount } from "@saberhq/token-utils";

export interface ClaimableAmounts {
  allClaimable: (TokenAmount | null)[];
  sum: TokenAmount | null;
}

export type GetAllClaimableAmounts = (
  amount?: number
) => ClaimableAmounts | null | undefined;
